// common
import dataAddRetry from '../dialogs/common/add_retry/data'
import dataApi from '../dialogs/common/api/data'
import dataCheckpoint from '../dialogs/common/checkpoint/data'
import dataClearRetry from '../dialogs/common/clear_retry/data'
import dataCode from '../dialogs/common/code/data'
import dataCondition from '../dialogs/common/condition/data'
import dataEnter from '../dialogs/common/enter/data'
import dataExit from '../dialogs/common/exit/data'
import dataGenAI from '../dialogs/common/gen_ai/data'
import dataIntentMapping from '../dialogs/common/intent_mapping/data'
import dataJump from '../dialogs/common/jump/data'
import dataLog from '../dialogs/common/log/data'
import dataLoop from '../dialogs/common/loop/data'
import dataMail from '../dialogs/common/mail/data'
import dataNote from '../dialogs/common/note/data'
import dataPage from '../dialogs/common/page/data'
import dataRandom from '../dialogs/common/random/data'
import dataSchedule from '../dialogs/common/schedule/data'
import dataStampService from '../dialogs/common/stamp_service/data'
import dataWrite from '../dialogs/common/write/data'

// voice
import dataVoiceDisconnect from '../dialogs/voice/disconnect/data'
import dataVoiceInput from '../dialogs/voice/input/data'
import dataVoicePrompt from '../dialogs/voice/prompt/data'
import dataVoiceReturnVxml from '../dialogs/voice/return_vxml/data'
import dataVoiceStart from '../dialogs/voice/start/data'
import dataVoiceTransfer from '../dialogs/voice/transfer/data'

//chat
import dataChatDisconnect from '../dialogs/chat/disconnect/data'
import dataChatInput from '../dialogs/chat/input/data'
import dataChatOutput from '../dialogs/chat/output/data'
import dataChatStart from '../dialogs/chat/start/data'
import dataChatTransfer from '../dialogs/chat/transfer/data'

class DataMapping {
  constructor(editor, nodeNameUnique) {
    this.editor = editor
    this.nodeNameUnique = nodeNameUnique
  }

  getDataMapping(data) {
    let output = {}
    switch (data.name) {
      // common
      case 'add_retry':
        output = dataAddRetry
        break
      case 'api':
        output = dataApi
        break
      case 'checkpoint':
        output = dataCheckpoint
        break
      case 'clear_retry':
        output = dataClearRetry
        break
      case 'code':
        output = dataCode
        break
      case 'condition':
        output = dataCondition
        break
      case 'enter':
        output = dataEnter
        break
      case 'exit':
        output = dataExit
        break
      case 'intent_mapping':
        output = dataIntentMapping
        break

      case 'jump':
        output = dataJump

        output.property.type = 'component'
        if (data.start) {
          output.property.type = 'exit_page'
          delete data.start
        }
        break
      case 'loop':
        output = dataLoop
        break
      case 'mail':
        output = dataMail
        break
      case 'note':
        output = dataNote
        break
      case 'page':
        output = dataPage
        break
      case 'random':
        output = dataRandom
        break
      case 'schedule':
        output = dataSchedule
        break
      case 'stamp_service':
        output = dataStampService
        break
      case 'write':
        output = dataWrite
        break
      case 'log':
        output = dataLog
        break
      case 'gen_ai':
        output = dataGenAI
        break
      // voice
      case 'disconnect':
        output = dataVoiceDisconnect
        break
      case 'input':
        output = dataVoiceInput
        break
      case 'prompt':
        output = dataVoicePrompt
        break
      case 'return_vxml':
        output = dataVoiceReturnVxml
        break
      case 'start':
        output = dataVoiceStart
        break
      case 'transfer':
        output = dataVoiceTransfer
        break
      // chat
      case 'chat_disconnect':
        output = dataChatDisconnect
        break
      case 'chat_input':
        output = dataChatInput
        break
      case 'chat_output':
        output = dataChatOutput
        break
      case 'chat_start':
        output = dataChatStart
        break
      case 'chat_transfer':
        output = dataChatTransfer
        break

      default:
        break
    }

    const node = JSON.parse(JSON.stringify(output))

    node.name = this.nodeNameUnique.includes(data.name)
      ? this.getNameWithOrder(data.name, data.title)
      : data.title
    node.ui = data

    return node
  }

  getNameWithOrder(node, title) {
    const drawflow = this.editor.export()
    if (!drawflow || !drawflow.drawflow) return 1

    let countNode = 0
    for (const tab in drawflow.drawflow) {
      if (drawflow.drawflow[tab]) {
        for (const index in drawflow.drawflow[tab].data) {
          const data = drawflow.drawflow[tab].data[index]
          if (data.name === node) {
            countNode += 1
          }
        }
      }
    }
    return this.checkAlreadyNameComponent(title, countNode)
  }

  checkAlreadyNameComponent(title, start) {
    const name = start > 0 ? `${title}-${start}` : title

    const item = this.editor.getNodesFromName(name) //_.find(this.items, { name })
    if (item && item.length > 0) {
      start += 1
      return this.checkAlreadyNameComponent(title, start)
    }
    return name
  }
}

export default DataMapping
